/**
 * We don't actually render `Tab` component anywhere, it's here to provide
 * nicer API. `Tab`s get transformed into array with data we care in their
 * parent, `TabbedModal`, above.
 */
const Tab = () => null
export default Tab
